import React, { useState, useCallback } from 'react'
import ErrorBoundary from '../errorboundry'
import { Form, Message, Grid } from 'semantic-ui-react'
import ProductTag from './productTag'
import MerchForm2 from './merchForm2'
import MerchForm3 from './merchForm3'
import MerchForm4 from './merchForm4'
import MerchForm5 from './merchForm5'
import AdditionalProcedure from './additionalProcedure'
import MerchForm8 from './merchForm8'
import CommercialDescription from './commercialDescription'
import PreviousDocument from './previousDocument'
import TaxInformation from './taxInformation'
import Certificate from './certificate'
import AdditionalInformation from './additionalInformation'
import AdditionalDeductions from './additionalDeductions'
import { deleteMechandiseItem, updateDataAfterSave } from '../../actions'
import { useDispatch, useSelector } from 'react-redux'
import { updateMechandiseItemById } from '../../actions/itemTabActions'
import Procedure from './procedure'
import { useEvent } from '../../hooks/useEvent'
import SupplyChainActor from './supplyChainActor'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { SAVE_ITEM_CDS } from '../../api/apiEvents'
import Containers from './container/index'
import ToggleInvoices from '../../../commonComponents/formComponents/toggleInvoices'
import MechandiseBar from './mechandiseBar'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import CustomCheckbox from '../../../commonComponents/formComponents/checkBox'
import { InvoiceToggleContext } from '@commonComponents/accordion/AccordianInvoice'
import { useContext } from 'react'

const JobStateArray  = ['STATE_ENTRY_AMEND_IN_PROCESS','STATE_ENTRY_AMEND_READY']

const MerchandiseDetails = ({ 
  invoiceId, 
  counter, 
  merchandiseId, 
  isFormEnabled,
  invoiceItemIndex,
  fieldPattern,
  validateError,
  initItemsTabValidationCDS,
}) => {
  const {state}=useContext(InvoiceToggleContext)
  const active=state[merchandiseId]
  const { currentJobState,isImportShipment } = useCurrentShipmentType()
  let checkCurrentJobStateFlag = JobStateArray.includes(currentJobState);
  const commodityCode = useSelector(
    (state) => state.InvoicesReducer.invoice.merchandise[merchandiseId]?.commodityCode || ''
  )
  const taricCode = useSelector(
    (state) => state.InvoicesReducer.invoice.merchandise[merchandiseId]?.taricCode
  )
  const commercialDescription = useSelector(
    (state) => state.InvoicesReducer.invoice.merchandise[merchandiseId]?.commercialDescription
  )
  const itemValue = useSelector(
    (state) => state.InvoicesReducer.invoice.merchandise[merchandiseId]?.itemValue
  )
  const originCountry = useSelector(
    (state) => state.InvoicesReducer.invoice.merchandise[merchandiseId]?.originCountry
  )
  const preference = useSelector(
    (state) => state.InvoicesReducer.invoice.merchandise[merchandiseId]?.preference
  )
  const sequenceNumeric = useSelector(
    (state) => state.InvoicesReducer.invoice.merchandise[merchandiseId]?.sequenceNumeric
  )
  const itemDeleted =
    useSelector((state) => state.InvoicesReducer.invoice.merchandise[merchandiseId]?.itemDeleted) ||
    '0'
  const amendmentAction = useSelector(
    (state) => state.InvoicesReducer.invoice.merchandise[merchandiseId]?.amendmentAction
  )||''

  const {serviceType} = useCurrentShipmentType()


  
  // const [lineflag, setLineFlag] = useState(false)
  // const [radioFlag, setRadioFlag] = useState(flag)
  const dispatch = useDispatch()
  const isFormDisabled = itemDeleted == '1' ? true : false

  const { saveForm, deleteForm, isLoading } = useEvent('invoice', true)

  const updateMechandiseById = useCallback(
    (params) => {
      dispatch(updateMechandiseItemById(merchandiseId, params))
    },
    [dispatch, updateMechandiseItemById, merchandiseId]
  )

  // const setActiveAccordian = () => {
  //   handleSingleLineItemToggle(merchandiseId) 
  // }

  const saveData = useCallback(
    async (params) => {
      saveForm(
        { merchandise: { [`${merchandiseId}`]: { invoiceId: invoiceId, ...params } } },
        false,
        SAVE_ITEM_CDS
      )
    },
    [merchandiseId, saveForm]
  )

  const saveFieldAndUpdateWithResponse = useCallback(
    async (params) => {
      let response = await saveForm(
        { merchandise: { [`${merchandiseId}`]: { invoiceId: invoiceId, ...params } } },
        false,
        SAVE_ITEM_CDS
      )
      if(response && response?.invoice?.merchandise){
         const [,value] = response?.invoice?.merchandise && Object.entries(response?.invoice?.merchandise)[0]  
         dispatch(updateMechandiseItemById(merchandiseId,value))   
      }
    },
    [merchandiseId, saveForm]
  )

  const saveInvoiceSummary = useCallback(
    async (params) => {
      let response = await saveForm(
        { merchandise: { [`${merchandiseId}`]: { invoiceId: invoiceId, ...params } } },
        false,
        SAVE_ITEM_CDS
      )
      if (response) {
        const invoiceHeader = response.invoice.invoiceHeader
        const [, value] = Object.entries(response.invoice.invoiceList)[0]
        const [, header] = Object.entries(value)[0]
        const updatedData = response.invoice.merchandise[merchandiseId]
        dispatch(updateDataAfterSave(invoiceId, { invoiceHeader, header }))
        dispatch(updateMechandiseItemById(merchandiseId,updatedData))
      }
    },
    [merchandiseId, invoiceId, saveForm]
  )

  const saveMassRelatedField = useCallback(
    async (params) => {
      let response = await saveForm(
        { merchandise: { [`${merchandiseId}`]: { invoiceId: invoiceId, ...params } } },
        false,
        SAVE_ITEM_CDS
      )
      if (response) {
        const invoiceHeader = response.invoice.invoiceHeader
        const [, value] = Object.entries(response.invoice.invoiceList)[0]
        const [, header] = Object.entries(value)[0]
        dispatch(updateDataAfterSave(invoiceId, { invoiceHeader, header }))
      }
    },
    [merchandiseId, invoiceId, saveForm]
  )

  const deleteData = useCallback(async () => {
    const response = await deleteForm({ merchandiseIds: [merchandiseId] })
    if (response) {
      const invoiceHeader = response.invoice.invoiceHeader
      const [, value] = Object.entries(response.invoice.invoiceList)[0]
      const [, header] = Object.entries(value)[0]
      const merchandise = response.invoice.merchandise
      dispatch(
        deleteMechandiseItem(invoiceId, merchandiseId, { invoiceHeader, header, merchandise })
      )
      dispatch(initItemsTabValidationCDS())
    }
  }, [invoiceId, merchandiseId, dispatch, deleteMechandiseItem, deleteForm])

  const markDeleted = useCallback(async () => {
    dispatch(
      updateMechandiseItemById(merchandiseId, { itemDeleted: itemDeleted == '1' ? '0' : '1' })
    )
    let response = await saveForm(
      {
        merchandise: {
          [`${merchandiseId}`]: {
            invoiceId: invoiceId,
            itemDeleted: itemDeleted == '1' ? '0' : '1',
          },
        },
      },
      false,
      SAVE_ITEM_CDS
    )
    if (response) {
      const invoiceHeader = response.invoice.invoiceHeader
      const header = response.invoice.invoiceList[invoiceId].header
      dispatch(updateDataAfterSave(invoiceId, { invoiceHeader, header }))
    }
  })

  const insertUpdate = useCallback(async () => {

    dispatch(
      updateMechandiseItemById(merchandiseId, {
        amendmentAction: amendmentAction == 'INSERT' ? '' : 'INSERT',
      })
    )
    let response = await saveForm(
      {
        merchandise: {
          [`${merchandiseId}`]: {
            invoiceId: invoiceId,
            amendmentAction: amendmentAction == 'INSERT' ? ' ' : 'INSERT',
          },
        },
      },
      false,
      SAVE_ITEM_CDS
    )
  })

  const markDeletedUI = () => {
    return (
      <CustomCheckbox
        checked={itemDeleted == '1' ? true : false}
        label={itemDeleted == '1' ? 'Marked Deleted' : 'Mark Deleted'}
        disabled={amendmentAction == 'INSERT'}
        onChange={(e) => {
          e.stopPropagation()
          markDeleted()
  }}
      />
    )
  }

  const insertUpdateUI = () => {
    return (
      <CustomCheckbox
        checked={amendmentAction=='INSERT'?true:false}
        label='UPDATE'
        disabled={itemDeleted=='1'}
        onChange={(e) => {
          e.stopPropagation()
          insertUpdate()
        }}
      />
    )
  }



  return (
    <ErrorBoundary>
      {isLoading && <CustomLoader />}

      <Message className='merchandise' color={itemDeleted == '1' ? 'red' : null}>
        <div
          id={`merchandiseDetail-${merchandiseId}`}
          columns={4}
        >
          <ToggleInvoices
            titleValue={
              <MechandiseBar
                commodityCode={commodityCode}
                taricCode={taricCode}
                commercialDescription={commercialDescription}
                itemValue={itemValue}
                originCountry={originCountry}
                preference={preference}
                serviceType={serviceType}
              />
            }
            toggleId={merchandiseId}
            invoiceId={invoiceId}
            // onClick={setActiveAccordian}
            title='merchandise'
            expandCollapseId={`expandCollapseMerch-${merchandiseId}`}
            deleteItemId={`deleteMerch${merchandiseId}`}
            confirmationMsg='Merchandise Line Item'
            containerStyle={{ marginBottom: '.5rem' }}
            isFormDisabled={isFormDisabled}
            lineNumber={counter}
            sequenceNumeric={sequenceNumeric}
            // isActive={active}
            onDelete={deleteData}
            markDeletedUI={checkCurrentJobStateFlag ? markDeletedUI : null}
            insertUpdateUI={checkCurrentJobStateFlag ? insertUpdateUI : null}
           
          />
        </div>
        {active && (
          <>
            <Form.Group className='float-container mb-2'>
              <Grid>
                <Grid.Row>
                  <ProductTag
                    isFormDisabled={isFormDisabled}
                    saveData={saveData}
                    updateData={updateMechandiseById}
                    merchandiseId={merchandiseId}
                    invoiceId={invoiceId}
                  />
                  <CommercialDescription
                    isFormDisabled={isFormDisabled}
                    saveData={saveData}
                    updateData={updateMechandiseById}
                    merchandiseId={merchandiseId}
                    invoiceId={invoiceId}
                    lineNumber={counter}
                    invoiceItemIndex={invoiceItemIndex}
                    fieldPattern={fieldPattern}
                    validateError={validateError}
                  />
                </Grid.Row>

                <MerchForm2
                  updateData={updateMechandiseById}
                  isFormDisabled={isFormDisabled}
                  merchandiseId={merchandiseId}
                  invoiceId={invoiceId}
                  saveData={saveData}
                  saveCommodityCode={saveFieldAndUpdateWithResponse}
                  lineNumber={counter}
                    invoiceItemIndex={invoiceItemIndex}
                    fieldPattern={fieldPattern}
                    validateError={validateError}
                />

                <MerchForm3
                  updateData={updateMechandiseById}
                  saveFieldAndUpdateWithResponse={saveFieldAndUpdateWithResponse}
                  isFormDisabled={isFormDisabled}
                  merchandiseId={merchandiseId}
                  invoiceId={invoiceId}
                  saveData={saveData}
                  lineNumber={counter}
                    invoiceItemIndex={invoiceItemIndex}
                    fieldPattern={fieldPattern}
                    validateError={validateError}
                />

                <MerchForm4
                  updateData={updateMechandiseById}
                  isFormDisabled={isFormDisabled}
                  merchandiseId={merchandiseId}
                  invoiceId={invoiceId}
                  saveData={saveData}
                  saveInvoiceSummary={saveInvoiceSummary}
                  saveMassRelatedField={saveMassRelatedField}
                  lineNumber={counter}
                  isImportShipment={isImportShipment}
                    invoiceItemIndex={invoiceItemIndex}
                    fieldPattern={fieldPattern}
                    validateError={validateError}

                />

                <MerchForm5
                  updateData={updateMechandiseById}
                  isFormDisabled={isFormDisabled}
                  merchandiseId={merchandiseId}
                  invoiceId={invoiceId}
                  saveData={saveData}
                  saveMassRelatedField={saveMassRelatedField}
                  lineNumber={counter}
                  isImportShipment={isImportShipment}
                    invoiceItemIndex={invoiceItemIndex}
                    fieldPattern={fieldPattern}
                    validateError={validateError}

                />
                { isImportShipment &&
                <MerchForm8
                  updateData={updateMechandiseById}
                  isFormDisabled={isFormDisabled}
                  merchandiseId={merchandiseId}
                  invoiceId={invoiceId}
                  saveData={saveData}
                  lineNumber={counter}

                />
                }

                <Procedure
                  updateData={updateMechandiseById}
                  isFormDisabled={isFormDisabled}
                  merchandiseId={merchandiseId}
                  invoiceId={invoiceId}
                  saveData={saveData}
                  isImportShipment={isImportShipment}
                  lineNumber={counter}
                  invoiceItemIndex={invoiceItemIndex}
                  fieldPattern={fieldPattern}
                  validateError={validateError}

                />
              </Grid>
            </Form.Group>

            {/* <ContainerDropdown
                    selectedContainerList={selectedContainerList}
                    dataSource={dataSource}

                    /> */}

            <AdditionalProcedure merchandiseId={merchandiseId} invoiceId={invoiceId} />

           {isImportShipment && <TaxInformation merchandiseId={merchandiseId} invoiceId={invoiceId} />}
            <PreviousDocument merchandiseId={merchandiseId} invoiceId={invoiceId} />
            <Certificate merchandiseId={merchandiseId} invoiceId={invoiceId} />
            <AdditionalInformation isImportShipment={isImportShipment} merchandiseId={merchandiseId} invoiceId={invoiceId} />

          {isImportShipment && <AdditionalDeductions merchandiseId={merchandiseId} invoiceId={invoiceId} /> }
            <SupplyChainActor merchandiseId={merchandiseId} invoiceId={invoiceId} />

            <Containers merchandiseId={merchandiseId} invoiceId={invoiceId} />
          </>
        )}
      </Message>
    </ErrorBoundary>
  )
}
export default React.memo(MerchandiseDetails)
